import { createValidator, isRequired } from 'app/validators/base'
// for new option react-select will create the label field, which will be sended as value to back-end

const trimValue = value => value?.name?.trim() || value?.label?.trim()

const validate = isRequired(value => (typeof value === 'undefined' ? value : trimValue(value)))

export default createValidator(validate, 'categoryTag')
